package org.beatonma.orbitals.compose.ui.theme.red

import androidx.compose.ui.graphics.Color

val md_theme_light_primary = Color(0xFFB72200)
val md_theme_light_onPrimary = Color(0xFFFFFFFF)
val md_theme_light_primaryContainer = Color(0xFFFFDAD3)
val md_theme_light_onPrimaryContainer = Color(0xFF3E0500)
val md_theme_light_secondary = Color(0xFF77574F)
val md_theme_light_onSecondary = Color(0xFFFFFFFF)
val md_theme_light_secondaryContainer = Color(0xFFFFDAD3)
val md_theme_light_onSecondaryContainer = Color(0xFF2C1510)
val md_theme_light_tertiary = Color(0xFF6E5D2E)
val md_theme_light_onTertiary = Color(0xFFFFFFFF)
val md_theme_light_tertiaryContainer = Color(0xFFF8E0A6)
val md_theme_light_onTertiaryContainer = Color(0xFF241A00)
val md_theme_light_error = Color(0xFFBA1A1A)
val md_theme_light_errorContainer = Color(0xFFFFDAD6)
val md_theme_light_onError = Color(0xFFFFFFFF)
val md_theme_light_onErrorContainer = Color(0xFF410002)
val md_theme_light_background = Color(0xFFFFFBFF)
val md_theme_light_onBackground = Color(0xFF201A19)
val md_theme_light_surface = Color(0xFFFFFBFF)
val md_theme_light_onSurface = Color(0xFF201A19)
val md_theme_light_surfaceVariant = Color(0xFFF5DDD9)
val md_theme_light_onSurfaceVariant = Color(0xFF534340)
val md_theme_light_outline = Color(0xFF85736F)
val md_theme_light_inverseOnSurface = Color(0xFFFBEEEB)
val md_theme_light_inverseSurface = Color(0xFF362F2D)
val md_theme_light_inversePrimary = Color(0xFFFFB4A4)
val md_theme_light_shadow = Color(0xFF000000)
val md_theme_light_surfaceTint = Color(0xFFB72200)
val md_theme_light_outlineVariant = Color(0xFFD8C2BD)
val md_theme_light_scrim = Color(0x6B000000)

val md_theme_dark_primary = Color(0xFFFFB4A4)
val md_theme_dark_onPrimary = Color(0xFF640E00)
val md_theme_dark_primaryContainer = Color(0xFF8C1800)
val md_theme_dark_onPrimaryContainer = Color(0xFFFFDAD3)
val md_theme_dark_secondary = Color(0xFFE7BDB4)
val md_theme_dark_onSecondary = Color(0xFF442A24)
val md_theme_dark_secondaryContainer = Color(0xFF5D3F39)
val md_theme_dark_onSecondaryContainer = Color(0xFFFFDAD3)
val md_theme_dark_tertiary = Color(0xFFDBC48C)
val md_theme_dark_onTertiary = Color(0xFF3C2F04)
val md_theme_dark_tertiaryContainer = Color(0xFF544519)
val md_theme_dark_onTertiaryContainer = Color(0xFFF8E0A6)
val md_theme_dark_error = Color(0xFFFFB4AB)
val md_theme_dark_errorContainer = Color(0xFF93000A)
val md_theme_dark_onError = Color(0xFF690005)
val md_theme_dark_onErrorContainer = Color(0xFFFFDAD6)
val md_theme_dark_background = Color(0xFF201A19)
val md_theme_dark_onBackground = Color(0xFFEDE0DD)
val md_theme_dark_surface = Color(0xFF201A19)
val md_theme_dark_onSurface = Color(0xFFEDE0DD)
val md_theme_dark_surfaceVariant = Color(0xFF534340)
val md_theme_dark_onSurfaceVariant = Color(0xFFD8C2BD)
val md_theme_dark_outline = Color(0xFFA08C88)
val md_theme_dark_inverseOnSurface = Color(0xFF201A19)
val md_theme_dark_inverseSurface = Color(0xFFEDE0DD)
val md_theme_dark_inversePrimary = Color(0xFFB72200)
val md_theme_dark_shadow = Color(0xFF000000)
val md_theme_dark_surfaceTint = Color(0xFFFFB4A4)
val md_theme_dark_outlineVariant = Color(0xFF534340)
val md_theme_dark_scrim = Color(0x6B000000)


val seed = Color(0xFFB82200)
